<div class="content_wrap_section">
    <div class="wrap_header_sectons contact_us_background">
        <div class="top_header_overlay"></div>
        <h1>お問合せ</h1>
    </div>

    <div class="contactus_contents">
        <div class="container">
            <div class="row">
                <div class="col-md-4">
                    <div class="office_address">
                        <div class="office_contents">
                            <h4>本社</h4>
                            <span class="OpenSansFonts" style="font-size: 18px;font-weight: 600;">Crimson AI Pvt. Ltd.</span>
                            <p  class="OpenSansFonts">8A, 8th Floor, Techniplex II, SV Road,<br /> Goregaon West, Mumbai,<br /> Maharashtra 400062, India </p>
                        </div>
                        <div class="office_contents">
                            <h4>日本法人</h4>
                            <!-- <p>Phone no.+91-22-61935000</p> -->
                            <p  class="OpenSansFonts">4th Daini-Denpa Building, 2-14-10 Soto-Kanda, Chiyoda-ku, Tokyo, 101-0021, Japan</p>
                        </div>
                        <div class="office_contents">
                            <h4>お問合せ先</h4>
                            <!-- <p>Phone no.+91-22-61935000</p> -->
                            <p>Eメール: <a href="mailto:support@trinka.ai"><span
                                        class="OpenSansFonts">support@trinka.ai</span></a></p>
                        </div>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="contact_forms">
                        <form [formGroup]="contactForm" (ngSubmit)="processForm()">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group"
                                        [ngClass]="(!contactForm.get('contactFormName').valid && contactForm.get('contactFormName').dirty) || (contactForm.get('contactFormName').touched && contactForm.get('contactFormName').pristine) ? 'TextFiledError' : '' ">
                                        <!-- <input type="text" formControlName="contactFormName" class="form-control" placeholder="お名前 *">
                                    <div class="error_msg_section" *ngIf="(!contactForm.get('contactFormName').valid && contactForm.get('contactFormName').dirty) || (contactForm.get('contactFormName').touched && contactForm.get('contactFormName').pristine)">
                                        <p>お名前を入力してください。</p>
                                    </div> -->
                                        <mat-form-field appearance="outline">
                                            <mat-label>お名前 *</mat-label>
                                            <input matInput placeholder="" formControlName="contactFormName"
                                                class="form-control">
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="col-sm-6">
                                    <div class="form-group"
                                        [ngClass]="(!contactForm.get('contactFormEmail').valid && contactForm.get('contactFormEmail').dirty) || (contactForm.get('contactFormEmail').touched && contactForm.get('contactFormEmail').pristine) ? 'TextFiledError' : '' ">
                                        <!-- <input type="text"  formControlName="contactFormEmail" class="form-control" placeholder="メールアドレス *">
                                    <div class="error_msg_section" *ngIf="(!contactForm.get('contactFormEmail').valid && contactForm.get('contactFormEmail').dirty) || (contactForm.get('contactFormEmail').touched && contactForm.get('contactFormEmail').pristine)">
                                        <p>メールアドレスを入力してください。</p>
                                    </div> -->
                                        <mat-form-field appearance="outline">
                                            <mat-label>メールアドレス *</mat-label>
                                            <input matInput placeholder="" formControlName="contactFormEmail"
                                                class="form-control">
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <!-- <div class="col-sm-12">
                                    <div class="form-group"
                                        [ngClass]="(!contactForm.get('contactFormSubjects').valid && contactForm.get('contactFormSubjects').dirty) || (contactForm.get('contactFormSubjects').touched && contactForm.get('contactFormSubjects').pristine) ? 'TextFiledError' : '' ">
                                        <mat-form-field appearance="outline">
                                            <mat-label>件名 *</mat-label>
                                            <input matInput placeholder="" formControlName="contactFormSubjects"
                                                class="form-control">
                                        </mat-form-field>
                                    </div>
                                </div> -->
                                <div class="col-sm-6">
                                    <div class="form-group"
                                        [ngClass]="(!contactForm.get('contactFormContactNumber').valid && contactForm.get('contactFormContactNumber').dirty) || (contactForm.get('contactFormContactNumber').touched && contactForm.get('contactFormContactNumber').pristine) ? 'TextFiledError' : '' ">
                                        <mat-form-field appearance="outline">
                                            <mat-label>連絡先電話番号*（ISDコードを含む）</mat-label>
                                            <input id="contactUserSubject" matInput placeholder="" formControlName="contactFormContactNumber"
                                                class="form-control">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group"
                                        [ngClass]="(!contactForm.get('contactFormOrgTitle').valid && contactForm.get('contactFormOrgTitle').dirty) || (contactForm.get('contactFormOrgTitle').touched && contactForm.get('contactFormOrgTitle').pristine) ? 'TextFiledError' : '' ">
                                        <mat-form-field appearance="outline">
                                            <mat-label>ご所属先またはお問い合わせ件名 *</mat-label>
                                            <input id="contactUserSubject" matInput placeholder="" formControlName="contactFormOrgTitle"
                                                class="form-control">
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group textareaBox"
                                        [ngClass]="(!contactForm.get('contactFormMessage').valid && contactForm.get('contactFormMessage').dirty) || (contactForm.get('contactFormMessage').touched && contactForm.get('contactFormMessage').pristine) ? 'TextFiledError' : '' ">
                                        <!-- <textarea name="containt" formControlName="contactFormMessage" class="form-control" placeholder="本文 *. . ."></textarea>
                                    <div class="error_msg_section message_error" *ngIf="(!contactForm.get('contactFormMessage').valid && contactForm.get('contactFormMessage').dirty) || (contactForm.get('contactFormMessage').touched && contactForm.get('contactFormMessage').pristine)">
                                        <p>お問い合わせ内容を入力してください。</p>
                                    </div> -->
                                        <mat-form-field appearance="outline">
                                            <mat-label>本文 *</mat-label>
                                            <textarea matInput formControlName="contactFormMessage" placeholder=""
                                                class="form-control"></textarea>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <button type="submit">送信</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="global_offices">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <h2>私たちのグローバルプレゼンス</h2>
                <div class="HeadingSubLine"></div>
                <p>私たちは、研究コミュニティへのサービスの可用性を促進するために、世界中に存在感を示しています。</p>
                    <div class="global-presence-wrap mart-20">
                        <div class="global-maps" style="position: relative;">
                            <div class="row">
                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap usa marr-10" id="usa" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name OpenSansFonts">ニュージャージー<br />（アメリカ）</div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap usa padb-20" id="usaview">
                                    <div class="row">
                                        <div class="col-md-12 col-xs-12 global-location">
                                            <div class="location-wrap OpenSansFonts" style="margin-left: 50px;">
                                                <h3>New Jersey, USA</h3>
                                                <p class="marb-10">
                                                    <br>&nbsp;
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap korea marr-20" id="korea" onclick="viewlocation(id)">

                                    <div class="map-box"></div>
                                    <div class="location-name OpenSansFonts">ソウル<br>（韓国）</div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap korea padb-20" id="koreaview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap OpenSansFonts">
                                            <h3>Seoul, Korea</h3>
                                            <p>Crimson Interactive Korea Co., Ltd.<br>
                                                #803-74, 1-Dong, 775, Gyeongin-ro, Yeongdeungpo-gu,
                                                Seoul, Republic of Korea    
                                                <br>
                                            </p>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap china marr-20" id="china" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name OpenSansFonts">北京/上海<br>（中国）</div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap china padb-20" id="chinaview">
                                    <div class="row">
                                        <div class="col-md-6  col-sm-6  col-xs-12 global-location">
                                            <div class="location-wrap OpenSansFonts"  style="margin-left: 50px;">
                                                <h3>Beijing, China</h3>
                                                <p class="marb-10">Room 607, Attempt Center, No. A6 Zhongguancun South
                                                    Street,
                                                    Haidian District, Beijing, China - 100086<br>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-md-6  col-sm-6 col-xs-12  global-location">
                                            <div class="location-wrap OpenSansFonts" style="margin-left: 50px;">
                                                <h3>Shangai, China</h3>
                                                <p class="marb-10">Room 101, No. 110, Tianlinshiyicun, Xuhui District,
                                                    Shanghai
                                                    200233<br>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap japan marr-20 active" id="japan" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name OpenSansFonts">東京 <br>（日本）</div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap japan padb-20 show" id="japanview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap OpenSansFonts">
                                            <h3>Tokyo, Japan</h3>
                                            <p class="marb-10">Crimson Interactive K.K.<br>
                                                4th Daini-Denpa Building, 2-14-10 Soto-Kanda, Chiyoda-ku, Tokyo,
                                                101-0021,
                                                Japan<br>
                                            </p>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap india" id="india" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name OpenSansFonts">ムンバイ<br>（インド）</div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap india padb-20 " id="indiaview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap OpenSansFonts">
                                            <h3>Mumbai, India</h3>
                                            <p class="marb-10">Crimson Interactive<br>
                                                1001, 10th Floor, Techniplex - II, Veer Savarkar Flyover, S. V. Road,
                                                Goregaon (W), Mumbai 400062, India<br>
                                            </p>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap uk" id="uk" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name OpenSansFonts">ロンドン<br>（イギリス）</div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap uk padb-20" id="ukview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap OpenSansFonts">
                                            <h3>London, United Kingdom</h3>
                                            <p class="marb-10">Woodberry House, 2 Woodberry Grove, Finchley, London, N12
                                                0DR, United Kingdom<br>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap turkey" id="turkey" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name OpenSansFonts">イスタンブール<br />（トルコ）</div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap turkey padb-20" id="turkeyview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap OpenSansFonts">
                                            <h3>Istanbul, Turkey</h3>
                                            <p class="marb-10">Levent Mah. Ulgen Sok. No:52 Besiktas Istanbul,
                                                TURKEY<br>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap taiwan" id="taiwan" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name OpenSansFonts">台北<br>（台湾）</div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap taiwan padb-20" id="taiwanview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap OpenSansFonts">
                                            <h3>Taipei, Taiwan</h3>
                                            <p class="marb-10">
                                                2F, No. 40, Ln 91, Sec.1, <br>
                                                Neihu Road, Neihu Dist., Taipei City 11441, Taiwan.
                                            </p>
                                        </div>
                                    </div>
                                </div>
   
                            </div>    
                        </div>
                    </div>
            </div>
        </div>
    </div>
</div>